/// <amd-module name="Repos/Editor/Components/EditorPreferencesPanel" />
import * as React from "react";
import { IEditorPreferencesPanelProps } from "Repos/Common/Contracts/Editor";
import { IVersionControlEditorPreferences } from "Repos/Common/Contracts/VersionControlViewModel";
import * as Resources from "Repos/Editor/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { Checkbox } from "VSSUI/Checkbox";
import { Panel } from "VSSUI/Panel";

export class EditorPreferencesPanel extends React.Component<IEditorPreferencesPanelProps> {
    private folding: ObservableValue<boolean>;
    private minimap: ObservableValue<boolean>;
    private whitespace: ObservableValue<boolean>;
    private wordWrap: ObservableValue<boolean>;

    constructor(props: IEditorPreferencesPanelProps) {
        super(props);

        const prefs = props.initialPreferences;

        this.folding = new ObservableValue(!!prefs.foldingEnabled);
        this.minimap = new ObservableValue(!!prefs.minimapEnabled);
        this.whitespace = new ObservableValue(!!prefs.whiteSpaceEnabled);
        this.wordWrap = new ObservableValue(!!prefs.wordWrapEnabled);
    }

    public render() {
        return (
            <Panel
                defaultActiveElement=".bolt-checkbox"
                onDismiss={() => {
                    this.props.onDismiss();
                }}
                titleProps={{ text: Resources.UserPreferencesPanelTitle }}
                footerButtonProps={[
                    {
                        onClick: () => {
                            this.props.onDismiss();
                        },
                        text: Resources.Cancel
                    },
                    {
                        onClick: () => {
                            const prefs: IVersionControlEditorPreferences = {
                                ...this.props.initialPreferences,
                                foldingEnabled: this.folding.value,
                                minimapEnabled: this.minimap.value,
                                whiteSpaceEnabled: this.whitespace.value,
                                wordWrapEnabled: this.wordWrap.value
                            };
                            this.props.onDismiss(prefs);
                        },
                        primary: true,
                        text: Resources.Save
                    }
                ]}
            >
                <div className="rhythm-vertical-8 flex-column">
                    <Checkbox
                        onChange={(event, checked) => (this.whitespace.value = checked)}
                        checked={this.whitespace}
                        label={Resources.PreferenceWhitespace}
                    />
                    <Checkbox
                        onChange={(event, checked) => (this.wordWrap.value = checked)}
                        checked={this.wordWrap}
                        label={Resources.PreferenceWordWrap}
                    />
                    {!this.props.isDiffEditor && (
                        <>

                            <Checkbox
                                onChange={(event, checked) => (this.folding.value = checked)}
                                checked={this.folding}
                                label={Resources.PreferenceFolding}
                            />
                            <Checkbox
                                onChange={(event, checked) => (this.minimap.value = checked)}
                                checked={this.minimap}
                                label={Resources.PreferenceMinimap}
                            />
                        </>
                    )}
                </div>
            </Panel>
        );
    }
}
